import axios from "axios";
import Vue from "vue";

axios.interceptors.request.use(function (config) {});

axios.interceptors.response.use(undefined, (error) => {
  return error;
});
const apiKey = [
  {
    brand_code: "CRM8FR5HTC1LJ9Y",
    apiKey: "BxJcM8ZRoHw3VpTk5NsF01dQy7LgaXv",
    apiRoute: "https://api-crmdemo-service-prod.d-dots.com/api/",
  },
];
function getBrandConfig() {
  const params = new URLSearchParams(window.location.search);
  const brandCode = params.get("brand_code");

  if (!brandCode) return null;

  return apiKey.find((item) => item.brand_code === brandCode);
}
const brandConfig = getBrandConfig();
const instance = axios.create({
  baseURL: brandConfig?.apiRoute || process.env.VUE_APP_API,
  responseType: "json",
});

instance.interceptors.request.use(function (config) {
  config.headers["API-KEY"] =
    brandConfig?.apiKey || process.env.VUE_APP_API_KEY;
  return config;
});

Vue.prototype.$Axios = axios;
Vue.prototype.axios = instance;

export { instance, axios };
